/* eslint-disable react/no-unknown-property */
import React from 'react'

import { bool, oneOf, shape, string } from 'prop-types'

function MosaicItem({ image, size, lazy = false }) {
  return (
    <div className={`image-mosaic-item image-mosaic-item--${size}`}>
      <img
        src={image.url}
        alt={image.alt}
        className="image-mosaic-image"
        loading={lazy ? 'lazy' : undefined}
        fetchpriority={lazy ? undefined : 'high'}
      />
    </div>
  )
}

MosaicItem.propTypes = {
  image: shape({
    id: string.isRequired,
    url: string.isRequired,
    alt: string.isRequired,
  }).isRequired,
  size: oneOf(['tall', 'short']).isRequired,
  lazy: bool,
}

export default MosaicItem
